export const offersConstants = {
  SET_OFFER_TO_MY: 'SET_OFFER_TO_MY',
  RESET_OFFER: 'RESET_OFFER',

  SET_OFFER_SUCCESS: 'SET_OFFER_SUCCESS',
  SET_OFFER_FAILURE: 'SET_OFFER_FAILURE',

  SET_OFFERS_LIST_REQUEST: 'SET_OFFERS_LIST_REQUEST',
  SET_OFFERS_LIST_SUCCESS: 'SET_OFFERS_LIST_SUCCESS',
  SET_OFFERS_LIST_FAILURE: 'SET_OFFERS_LIST_FAILURE',

  SET_OFFER_FILTERS_REQUEST: 'SET_OFFER_FILTERS_REQUEST',
  SET_OFFER_FILTERS_FAILURE: 'SET_OFFER_FILTERS_FAILURE',
  SET_OFFER_FILTERS_SUCCESS: 'SET_OFFER_FILTERS_SUCCESS',

  RESET_OFFERS_CATALOG_FILTER: 'RESET_OFFERS_CATALOG_FILTER',
  SET_OFFERS_CATALOG_FILTER: 'SET_OFFERS_CATALOG_FILTER',

  SET_OFFERS_TABS_SUCCESS: 'SET_OFFERS_TABS_SUCCESS',
  SET_OFFERS_TABS_FAILURE: 'SET_OFFERS_TABS_FAILURE',
  SET_OFFERS_TABS_REQUEST: 'SET_OFFERS_TABS_REQUEST',

  SET_OFFER_NEWS_REQUEST: 'SET_OFFER_NEWS_REQUEST',
  SET_OFFER_NEWS_SUCCESS: 'SET_OFFER_NEWS_SUCCESS',
  SET_OFFER_NEWS_FAILURE: 'SET_OFFER_NEWS_FAILURE',

  SET_OFFER_FILES_REQUEST: 'SET_OFFER_FILES_REQUEST',
  SET_OFFER_FILES_SUCCESS: 'SET_OFFER_FILES_SUCCESS',
  SET_OFFER_FILES_FAILURE: 'SET_OFFER_FILES_FAILURE',

  SET_OFFER_PROMO_REQUEST: 'SET_OFFER_PROMO_REQUEST',
  SET_OFFER_PROMO_SUCCESS: 'SET_OFFER_PROMO_SUCCESS',
  SET_OFFER_PROMO_FAILURE: 'SET_OFFER_PROMO_FAILURE',

  SET_OFFER_EXTRA_GROUPS_REQUEST: 'SET_OFFER_EXTRA_GROUPS_REQUEST',
  SET_OFFER_EXTRA_GROUPS_SUCCESS: 'SET_OFFER_EXTRA_GROUPS_SUCCESS',
  SET_OFFER_EXTRA_GROUPS_FAILURE: 'SET_OFFER_EXTRA_GROUPS_FAILURE',

  SET_OFFER_EXTRA_COLLECTION_SUCCESS: 'SET_OFFER_EXTRA_COLLECTION_SUCCESS',
  SET_OFFER_EXTRA_COLLECTION_FAILURE: 'SET_OFFER_EXTRA_COLLECTION_FAILURE',

  SET_RECOMMENDED_OFFERS_SUCCESS: 'SET_RECOMMENDED_OFFERS_SUCCES',
  SET_RECOMMENDED_OFFERS_FAILURE: 'SET_RECOMMENDED_OFFERS_FAILURE',

  SET_LANDINGS_INFO: 'SET_LANDINGS_INFO',
  RESET_OFFER_PROMO: 'RESET_OFFER_PROMO',

  CANCEL_REQUEUS: 'CANCEL_REQUEUS',

  SET_OFFER_SUPPORT_HOURS_SUCCESS: 'SET_OFFER_SUPPORT_HOURS_SUCCESS',
  SET_OFFER_SUPPORT_HOURS_FAILURE: 'SET_OFFER_SUPPORT_HOURS_FAILURE',
};
